import { List, useTheme } from '@mui/material';
import { useEffect, useRef } from 'react';
import { VideoGroupSkeleton } from '../VideoGroupSkeleton.tsx';
import { Season } from './Season.tsx';
import { type SeasonData } from './types.ts';

export type SeasonsAndEpisodesProps = {
  onEpisodeClick: (season: number, episode: number) => void;
  seasons: SeasonData[];
  selectedEpisodeNumber: number;
  selectedSeasonNumber: number;
};

export const SeasonsAndEpisodes = ({
  onEpisodeClick,
  seasons,
  selectedEpisodeNumber,
  selectedSeasonNumber,
}: SeasonsAndEpisodesProps) => {
  const theme = useTheme();
  const selectedEpisodeRef = useRef<HTMLLIElement | null>(null);

  useEffect(() => {
    if (selectedEpisodeRef.current) {
      selectedEpisodeRef.current.scrollIntoView();
    }
  }, [selectedSeasonNumber, selectedEpisodeNumber]);

  return (
    <List
      sx={{
        color: theme.mainTextPrimary,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflowY: 'scroll',
        paddingBottom: 0,
        paddingTop: 0,
      }}
    >
      {seasons.length > 0 ? (
        seasons.map(season =>
          season.episodes.length > 0 ? (
            <Season
              {...season}
              key={season.id}
              onEpisodeClick={onEpisodeClick}
              selected={season.seasonNumber === selectedSeasonNumber}
              selectedEpisodeNumber={selectedEpisodeNumber}
              selectedEpisodeRef={selectedEpisodeRef}
            />
          ) : undefined,
        )
      ) : (
        <VideoGroupSkeleton />
      )}
    </List>
  );
};
